import { render, staticRenderFns } from "./TicketListItem.vue?vue&type=template&id=09850c90"
import script from "./TicketListItem.vue?vue&type=script&lang=ts"
export * from "./TicketListItem.vue?vue&type=script&lang=ts"
import style0 from "./TicketListItem.vue?vue&type=style&index=0&id=09850c90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports